import React from 'react';
import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoClose } from 'react-icons/io5';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 border-customGreen bg-customGreen">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <a href="/" className="flex items-center space-x-3">
          <img src="/logo512.png" className="h-8" alt="Lotez" />
          <span className="text-white self-center text-3xl font-bold whitespace-nowrap">
            Lotez
          </span>
        </a>
        <button
          type="button"
          className={`${
            isMenuOpen
              ? 'hidden'
              : 'inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden'
          } `}
          onClick={toggleMenu}
        >
          <GiHamburgerMenu className="text-2xl text-white" />
        </button>
        <button
          type="button"
          className={` ${
            isMenuOpen
              ? 'inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden'
              : 'hidden'
          }`}
          onClick={toggleMenu}
        >
          <IoClose className="text-2xl text-white" />
        </button>
        <div
          className={`w-full md:block ${
            isMenuOpen ? 'block' : 'hidden'
          } md:w-auto`}
        >
          <ul className="flex flex-col mt-3 bg-transparent md:flex-row text-xl font-semibold md:space-x-8">
            <li>
              <NavLink
                to="/"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="block py-2 px-3 md:p-0 text-white hover:text-green rounded md:bg-transparent"
                aria-current="page"
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className="block py-2 px-3 md:p-0 text-white hover:text-green rounded md:bg-transparent"
              >
                About
              </NavLink>
            </li>
            <li>
              <HashLink
                to="/#services"
                className="block py-2 px-3 md:p-0 text-white hover:text-green rounded md:bg-transparent"
              >
                Services
              </HashLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className="block py-2 px-3 md:p-0 text-white hover:text-green rounded md:bg-transparent"
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
